import UserApiKeyResourcePagingResultModel from '../../generated/types/model/resource/UserApiKeyResourcePagingResultModel';

export default class UserApiKeyResourcePagingResultViewModel extends UserApiKeyResourcePagingResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
